<template>
    <div>
        <v-dialog transition="dialog-top-transition" max-width="600" v-model="login">
            <v-card>
                <v-card-text class="py-0 px-0">
                    <v-form ref="formLogin" lazy-validation>
                        <v-alert border="right" colored-border color="#8e84c0" elevation="0"
                            class="col-12 px-10 py-10 mb-0">
                            <div class="text-left">
                                <v-row class="mb-0">
                                    <v-icon class="ml-2 mt-n1" size="26px" color="#454547">
                                        mdi-shield-key
                                    </v-icon>
                                    <h2 class="mb-2 mt-1 ml-2 mt-0 title-modal">{{ $t('navbar.access') }}</h2>
                                </v-row>
                                <p class="mb-10 desc">{{ $t('navbar.access-desc') }}</p>

                                <v-text-field v-model="email" id="email" :label="$t('navbar.email')" type="email"
                                    outlined clearable color="#8e84c0" class="mb-0"
                                    :rules="[rules.required, rules.email]"></v-text-field>

                                <div class="password-field-container">
                                    <v-text-field v-model="password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                        :rules="[rules.required, rules.min]" :type="show1 ? 'text' : 'password'"
                                        :label="$t('navbar.password')" color="#8e84c0" outlined clearable
                                        @click:append="show1 = !show1" />
                                </div>
                            </div>
                            <div class="text-right mt-2 option-register">
                                <v-btn :disabled="!isFormValidLogin || loginLoading" @click="logUser()"
                                    :loading="loginLoading" color="#8e84c0"
                                    class="ml-0 white--text link ma-2 rounded-md px-16 col-12 col-md-5">
                                    <v-icon left color="white">
                                        mdi-cloud-key-outline
                                    </v-icon>
                                    {{ $t('navbar.access-button') }}
                                </v-btn>

                                <div class="password-field-container">
                                    <div class="forgot-password float-left px-1">
                                        <v-btn color="black" class="white--text link ma-2 rounded-xl hidden-sm-and-down py-4" small
                                        @click="registerModal()">
                                            <v-icon left>
                                                mdi-plus-circle-outline
                                            </v-icon>
                                            {{ $t('navbar.register') }}
                                        </v-btn>
                                        <v-btn color="black" class="white--text link ma-2 rounded-xl hidden-md-and-up py-4" small
                                        @click="registerModal()">
                                            <v-icon left>
                                                mdi-plus-circle-outline
                                            </v-icon>
                                            {{ $t('navbar.register') }}
                                        </v-btn>
                                    </div>
                                </div>
                            </div>
                        </v-alert>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog transition="dialog-top-transition" max-width="600" v-model="register">
            <v-card class="register-card">
                <v-card-text class="py-0 px-0">
                    <v-form ref="formRegister" lazy-validation>
                        <v-alert border="right" colored-border color="#8e84c0" elevation="0"
                            class="col-12 px-10 py-10 mb-0 register-content">
                            <div class="text-left">
                                <v-row class="mb-0">
                                    <v-icon class="ml-2 mt-n1" size="26px" color="#454547">
                                        mdi-shield-account
                                    </v-icon>
                                    <h2 class="mb-2 mt-4 ml-2 mt-0 title-modal">{{ $t('navbar.register') }}</h2>
                                </v-row>
                                <p class="mb-10 desc">{{ $t('navbar.register-desc') }}</p>

                                <v-row>
                                    <v-col cols="12" md="6" class="pa-0 mobile-input">
                                        <v-text-field id="first_name" v-model="first_name" :label="$t('navbar.name')"
                                            type="text" outlined clearable color="#8e84c0"
                                            class="mb-0 input-capitalize px-3"
                                            :rules="[rules.required, rules.alpha, rules.minName, rules.maxName]"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6" class="pa-0 mobile-input">
                                        <v-text-field v-model="last_name" id="last_name" :label="$t('navbar.last-name')"
                                            type="text" outlined clearable color="#8e84c0"
                                            class="mb-3 mb-md-2 input-capitalize px-3"
                                            :rules="[rules.required, rules.alpha, rules.minName, rules.maxName]"></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-text-field v-model="email" id="email" name="email" :label="$t('navbar.email')"
                                    type="email" outlined clearable color="#8e84c0" class="mb-0"
                                    :rules="[rules.required, rules.email]"></v-text-field>

                                <v-row>
                                    <div class="col-12 col-md-4 pb-0 m-0 mobile-phone-code">
                                        <v-autocomplete v-model="phone_code" :items="phone_codes" item-text="dial_code"
                                            item-value="dial_code" color="#8e84c0" outlined
                                            :label="$t('navbar.dial-code')" class="pr-0 pr-md-1"
                                            :rules="[rules.required]">
                                            <template v-slot:selection="{ item }">
                                                <v-avatar size="24">
                                                    <img :src="item.flag" />
                                                </v-avatar>
                                                <span class="ml-2">{{ item.dial_code }}</span>
                                            </template>
                                            <template v-slot:item="{ item }">
                                                <v-avatar size="24">
                                                    <img :src="item.flag" />
                                                </v-avatar>
                                                <span class="ml-2">{{ item.dial_code }}</span>
                                            </template>
                                        </v-autocomplete>
                                    </div>

                                    <div class="col-12 col-md-8 py-0 pb-2 py-md-3 mobile-phone-number">
                                        <v-text-field id="phone_number" v-model="phone_number"
                                            :label="$t('navbar.phone')" type="text" outlined clearable color="#8e84c0"
                                            class="mb-0 pl-0 pl-md-1"
                                            :rules="[rules.required, rules.numericPhone, rules.minPhone, rules.maxPhone]">
                                            <template v-slot:append>
                                                <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    >
                                                    mdi-information-outline
                                                    </v-icon>
                                                </template>
                                                <span>{{$t('navbar.phone-tooltip')}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-text-field>
                                    </div>
                                </v-row>

                                <v-autocomplete
                                    outlined
                                    :label="$t('navbar.userType')"
                                    :items="userType"
                                    item-value="id"
                                    item-text="name"
                                    v-model="role_id"
                                    color="#8e84c0"
                                    :rules="[rules.required]"
                                    :disabled="registerLoading"
                                >
                                    <!-- Renderizado de los ítems en la lista -->
                                    <template v-slot:item="{ item, on, attrs }">
                                        <v-list-item v-bind="attrs" v-on="on">
                                            <v-list-item-content>
                                                <v-list-item-title class="text-left"><span v-html="item.name"></span></v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </template>
                                </v-autocomplete>

                                <v-text-field v-model="password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                    :rules="[rules.required, rules.min]" :type="show1 ? 'text' : 'password'"
                                    :label="$t('navbar.password')" counter color="#8e84c0" outlined clearable
                                    @click:append="show1 = !show1"></v-text-field>

                                <v-text-field v-model="password_confirm"
                                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                    :rules="[rules.required, rules.min, rules.passwordMatch]"
                                    :type="show1 ? 'text' : 'password'" :label="$t('navbar.confirm-password')" counter
                                    color="#8e84c0" outlined clearable @click:append="show1 = !show1"></v-text-field>
                            </div>
                            <div class="text-right">
                                <v-btn :disabled="!isFormValidRegister || registerLoading" @click="registerUser()"
                                    :loading="registerLoading" color="#8e84c0"
                                    class="ml-0 white--text link ma-2 rounded-md px-16 col-12 col-md-5">
                                    <v-icon left color="white">
                                        mdi-account-key-outline
                                    </v-icon>
                                    {{ $t('navbar.register-button') }}
                                </v-btn>
                            </div>
                        </v-alert>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from '@/axios.js';

export default {
    name: 'LoginRegister',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        activityLog: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            login: false,
            register: false,
            loginLoading: false,
            registerLoading: false,
            email: '',
            password: '',
            password_confirm: '',
            first_name: '',
            last_name: '',
            phone_code: '',
            phone_number: '',
            role_id: 3,
            show1: false,
            phone_codes: [],
            userType: [],
            rules: {
                required: value => !!value || this.$t('navbar.required'),
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || this.$t('navbar.invalid-email');
                },
                min: value => value.length >= 6 || this.$t('navbar.min'),
                minName: value => value.length >= 2 || this.$t('navbar.min-name'),
                maxName: value => value.length <= 60 || this.$t('navbar.max-name'),
                alpha: value => /^[a-zA-ZÀ-ú\s]+$/.test(value) || this.$t('navbar.only-letters'),
                passwordMatch: value => value === this.password || this.$t('navbar.passwords-not-match'),
                numericPhone: value => /^[0-9]+$/.test(value) || this.$t('navbar.only-numbers'),
                minPhone: value => value.length >= 8 || this.$t('navbar.min-phone'),
                maxPhone: value => value.length <= 15 || this.$t('navbar.max-phone'),
            }
        }
    },
    computed: {
        isFormValidLogin() {
            return (
                this.email &&
                this.password &&
                this.password.length >= 6
            );
        },
        isFormValidRegister() {
            return (
                this.email &&
                this.password &&
                this.password_confirm &&
                this.password === this.password_confirm &&
                this.first_name &&
                this.last_name &&
                this.phone_code &&
                this.phone_number &&
                this.role_id
            );
        }
    },
    watch: {
        value(newValue) {
            this.login = newValue;
        },
        login(val) {
            this.$emit('input', val);
            if (!val) {
                this.$emit('login-closed');
            }
        }
    },
    methods: {
        async logUser() {
            try {
                this.loginLoading = true;
                const response = await axios.post('/login', {
                    email: this.email,
                    password: this.password
                });
                
                localStorage.removeItem("impersonate_admin");
                localStorage.setItem("user", JSON.stringify(response.data.user));
                localStorage.setItem("token", response.data.user.token);
                
                this.$root.$emit('userUpdated', response.data.user);

                this.$vs.notify({
                    title: this.$t('navbar.login-title'),
                    text: this.$t('navbar.login-success'),
                    color: 'success',
                    icon: 'check_box',
                    position: 'bottom-center',
                    time: 5000,
                });

                this.email = '';
                this.password = '';
                this.$refs.formLogin.resetValidation();
                this.loginLoading = false;
                this.login = false;
                
                this.$emit('login-success', this.activityLog);

            } catch (error) {
                console.error(error);

                localStorage.removeItem("user");
                localStorage.removeItem("token");

                this.loginLoading = false;

                if (error.response && error.response.status == 403) {
                    this.$vs.notify({
                        title: this.$t('navbar.error'),
                        text: this.$t('navbar.account-deactivated'),
                        color: 'danger',
                        icon: 'warning',
                        position: 'bottom-center',
                        time: 5000,
                    });
                } else {
                    this.$vs.notify({
                        title: this.$t('navbar.login-title-failed'),
                        text: this.$t('navbar.login-invalid'),
                        color: 'danger',
                        icon: 'warning',
                        position: 'bottom-center',
                        time: 5000,
                    });
                }
            }
        },
        registerModal() {
            this.login = false;
            this.getPhoneCodes();
            this.setUserType();
            this.email = '';
            this.password = '';
            this.password_confirm = '';
            this.register = true;
        },
        async registerUser() {
            const referralCode = localStorage.getItem('referral');
            try {
                this.registerLoading = true;
                const response = await axios.post('/register', {
                    first_name: this.first_name,
                    last_name: this.last_name,
                    email: this.email,
                    phone_code: this.phone_code,
                    phone_number: this.phone_number,
                    password: this.password,
                    password_confirmation: this.password_confirm,
                    role_id: this.role_id,
                    referral: referralCode
                });
                
                localStorage.setItem("user", JSON.stringify(response.data));
                localStorage.setItem("token", response.data.token);
                
                this.$root.$emit('userUpdated', response.data);

                this.$vs.notify({
                    title: this.$t('navbar.register-complete'),
                    text: this.$t('navbar.register-com-desc'),
                    color: 'success',
                    icon: 'check_box',
                    position: 'bottom-center',
                    time: 5000,
                });

                this.registerLoading = false;
                this.register = false;
                
                this.$emit('register-success', this.activityLog);
                
                window.open('/panel', '_blank');
                window.location.reload();
            } catch (error) {
                console.error(error);

                localStorage.removeItem("user");
                localStorage.removeItem("token");

                if (error.response && error.response.data.errors) {
                    if (error.response.data.errors.email) {
                        let errorData = error.response.data.errors.email;
                        errorData.forEach(element => {
                            if (element == 'The email has already been taken.') {
                                this.$vs.notify({
                                    title: this.$t('navbar.login-title-failed'),
                                    text: this.$t('navbar.email-taken'),
                                    color: 'danger',
                                    icon: 'warning',
                                    position: 'bottom-center',
                                    time: 5000,
                                });
                            }
                        });
                    } else if (error.response.data.errors.phone_number) {
                        let errorData = error.response.data.errors.phone_number;
                        errorData.forEach(element => {
                            if (element == 'The phone number has already been taken.') {
                                this.$vs.notify({
                                    title: this.$t('navbar.login-title-failed'),
                                    text: this.$t('navbar.phone-taken'),
                                    color: 'danger',
                                    icon: 'warning',
                                    position: 'bottom-center',
                                    time: 5000,
                                });
                            }
                        });
                    } else {
                        this.$vs.notify({
                            title: this.$t('navbar.login-title-failed'),
                            text: this.$t('navbar.register-failed'),
                            color: 'danger',
                            icon: 'warning',
                            position: 'bottom-center',
                            time: 5000,
                        });
                    }
                }

                this.registerLoading = false;
            }
        },
        setUserType() {
            this.userType = [
                { id: 3, name: this.$t('navbar.userCreator') },
                { id: 2, name: this.$t('navbar.userViewer') },
            ];
        },
        async getPhoneCodes() {
            try {
                const response = await axios.get('/get-phone-codes');

                this.phone_codes = response.data.map(code => {
                    code.flag = `https://flagcdn.com/24x18/${code.code.toLowerCase()}.png`;
                    return code;
                });
                
            } catch (error) {
                console.error(error);
            }
        }
    }
}
</script>

<style scoped>
.option-register {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

@media (max-width: 600px) {
    .option-register {
        flex-direction: column;
    }
    
    .register-card {
        max-height: 90vh;
        overflow-y: auto;
    }
    
    .register-content {
        overflow-y: visible;
        height: auto;
        padding: 10px !important;
    }
    
    .v-dialog {
        margin: 0;
        position: fixed;
        top: 5%;
        height: 90%;
        overflow-y: auto;
        width: 95% !important;
    }
    
    .v-text-field {
        margin-bottom: 10px !important;
    }
    
    .v-input--selection-controls {
        margin-top: 0 !important;
    }
    
    .v-btn {
        margin: 5px !important;
    }
    
    .mobile-input {
        width: 100% !important;
    }
    
    .mobile-phone-code,
    .mobile-phone-number {
        padding: 2px 6px !important;
    }
    
    .mobile-phone-code {
        margin-bottom: 10px !important;
    }
    
    .forgot-password {
        width: 100%;
        text-align: center;
        margin-top: 10px;
    }
    
    .forgot-password .v-btn {
        width: 100%;
    }
}

.title-modal {
    color: #454547;
    font-size: 22px;
    font-weight: 600;
}

.desc {
    color: #9BA9BD;
    font-size: 14px;
    font-weight: 400;
}
</style> 